(() => {
	let disclaimer = document.querySelector('[data-program-disclaimer]');
	if (!disclaimer) {
		return;
	}
	let toggle           = disclaimer.querySelector('[data-program-disclaimer-toggle]');
	let container        = disclaimer.querySelector('[data-program-disclaimer-container]');
	let toggleDisclaimer = e => {
		e.stopPropagation();
		e.preventDefault();
		let clone              = container.cloneNode(true);
		let rect;
		clone.style.maxHeight  = 'none';
		clone.style.visibility = 'hidden';
		container.parentNode.appendChild(clone);
		rect = clone.getBoundingClientRect();
		container.parentNode.removeChild(clone);
		if (disclaimer.getAttribute('data-program-disclaimer-toggled')) {
			container.style.maxHeight = '0';
			disclaimer.removeAttribute('data-program-disclaimer-toggled');
			return;
		}
		container.style.maxHeight = rect.height + 'px';
		disclaimer.setAttribute('data-program-disclaimer-toggled', 'true');
	};
	toggle.addEventListener('click', toggleDisclaimer);
})();